// /app/frontend/src/data/ressourcesFiches.js
// Fiches éditoriales natives codevoiture.fr enrichissant les documents PDF officiels.
// Chaque slug correspond à un document du catalogue titreProDocs (mockPages.js).
// Contenu original rédigé pour les élèves — vulgarisation, points-clés actionnables.

export const RESSOURCES_FICHES = {
  'alcoolemie': {
    pdfHref: '/docs/Alcoolemie.pdf',
    title: 'Alcoolémie : seuils légaux et effets sur la conduite',
    category: 'Risques & comportements',
    color: 'red',
    summary: "L'alcool est responsable d'environ 30 % de la mortalité routière. Comprendre les seuils légaux, les effets physiologiques et les conséquences juridiques te permet de prendre des décisions éclairées avant de prendre le volant.",
    keyPoints: [
      'Seuil légal : 0,5 g/L de sang (0,25 mg/L d\'air expiré) pour un conducteur expérimenté.',
      'Permis probatoire : seuil abaissé à 0,2 g/L de sang (0,10 mg/L d\'air expiré). Tolérance zéro.',
      'À 0,5 g/L : risque d\'accident multiplié par 2. À 0,8 g/L : multiplié par 10.',
      'Effets immédiats : champ visuel rétréci, temps de réaction allongé, jugement altéré, perception des distances perturbée.',
      'Sanction : retrait de 6 points minimum, amende jusqu\'à 4 500 €, suspension de permis, voire annulation et prison.',
    ],
    whyMatters: "En tant que jeune conducteur, tu es en permis probatoire : le moindre verre te met au-dessus du seuil. La vraie règle simple : si tu bois, tu ne conduis pas.",
  },
  'doses-alcool': {
    pdfHref: '/docs/Doses_alcool.pdf',
    title: 'Doses d\'alcool standard : ce qu\'un verre représente vraiment',
    category: 'Risques & comportements',
    summary: "Un \"verre\" en bar contient toujours environ 10 grammes d'alcool pur, peu importe la boisson. Cette équivalence est trompeuse car on sous-estime souvent ce qu'on a bu chez soi.",
    keyPoints: [
      'Une dose standard = 10 g d\'alcool pur = ~0,20 à 0,25 g/L dans le sang chez un adulte.',
      'Équivalence : 1 verre de vin (10 cl) ≈ 1 demi de bière (25 cl à 5°) ≈ 1 verre d\'apéritif (2,5 cl à 45°) ≈ 1 dose de whisky (3 cl).',
      'À la maison, les verres servis sont souvent 2 à 3× plus grands que la dose standard.',
      'Le corps élimine en moyenne 0,10 à 0,15 g/L par heure — impossible à accélérer.',
    ],
    whyMatters: "Ce document t'aide à mieux estimer ce que tu as réellement consommé en soirée. Indispensable avant de \"calculer\" combien de temps attendre avant de reprendre le volant.",
  },
  'elimination-alcool': {
    pdfHref: '/docs/Elimination_alcool.pdf',
    title: 'Élimination de l\'alcool : démystifier les idées reçues',
    category: 'Risques & comportements',
    summary: "Café noir, douche froide, sport, eau citronnée : aucune de ces méthodes n'accélère l'élimination de l'alcool. Seul le temps fait son œuvre.",
    keyPoints: [
      'Le foie élimine en moyenne 0,10 à 0,15 g/L par heure. Aucun moyen connu d\'accélérer ce processus.',
      'Le café masque la sensation de fatigue mais ne diminue PAS l\'alcoolémie.',
      '5 verres bus en 1 h = au moins 5 à 10 h pour redescendre sous le seuil légal.',
      'Le matin après une soirée : tu peux encore être positif à l\'éthylotest, même si tu te sens "frais".',
      'Astuce : un éthylotest jetable coûte 1 € en pharmacie. À utiliser avant de prendre le volant si doute.',
    ],
    whyMatters: "Si tu sors le soir, plan B obligatoire : taxi, transports en commun, conducteur désigné qui s\'engage à ne PAS boire. Pas de \"je gère\".",
  },
  'fatigue-substances': {
    pdfHref: '/docs/Fatigue_substances.pdf',
    title: 'Fatigue, médicaments et substances : le tueur silencieux',
    category: 'Risques & comportements',
    summary: "La fatigue est responsable d'environ 25 % des accidents mortels sur autoroute. C'est l'un des facteurs les plus sous-estimés, devant l'alcool.",
    keyPoints: [
      'Conduire après 17 h éveillé sans sommeil = équivalent à 0,5 g/L d\'alcool dans le sang.',
      'Conduire après 24 h éveillé = équivalent à 1,0 g/L (le double du seuil légal).',
      'Pause OBLIGATOIRE toutes les 2 h ou tous les 200 km sur long trajet.',
      'Médicaments : pictogramme noir/jaune/rouge sur la boîte = consulte ton pharmacien avant de conduire.',
      'Cannabis : multiplie par 2 le risque d\'accident. Cumul cannabis + alcool : par 14.',
    ],
    whyMatters: "Le micro-sommeil dure 1 à 5 secondes pendant lesquelles tu peux parcourir 50 à 150 mètres. La seule parade : t'arrêter dès les premiers signes (bâillements, paupières lourdes, mauvaise concentration).",
  },
  'energie-cinetique': {
    pdfHref: '/docs/Energie_cinetique.pdf',
    title: 'Énergie cinétique : pourquoi 10 km/h de plus changent tout',
    category: 'Risques & comportements',
    summary: "L'énergie cinétique d'un véhicule augmente avec le CARRÉ de sa vitesse. Cela signifie qu'en passant de 50 à 70 km/h, ton énergie de choc est presque doublée.",
    keyPoints: [
      'Formule : E = ½ × m × v². L\'énergie dépend de la masse mais surtout du CARRÉ de la vitesse.',
      'Passage de 50 à 70 km/h : énergie x 1,96 (presque doublée).',
      'Passage de 90 à 130 km/h : énergie x 2,1 (plus du double).',
      'Tout cette énergie doit être absorbée en cas de choc — par la carrosserie, mais aussi par ton corps.',
      'À 50 km/h, un choc frontal contre un mur = chute du 3e étage. À 90 km/h = du 10e étage.',
    ],
    whyMatters: "Quand tu choisis ta vitesse, tu choisis aussi la violence du choc en cas d\'accident. La vitesse n\'est pas qu\'une question d\'amende.",
  },
  'temps-de-reaction': {
    pdfHref: '/docs/Reaction_freinage_arret.pdf',
    title: 'Distance d\'arrêt : ce qu\'on oublie toujours',
    category: 'Risques & comportements',
    summary: "La distance d'arrêt n'est pas la distance de freinage. Elle additionne le temps de perception + le temps de réaction + le freinage proprement dit.",
    keyPoints: [
      'Distance d\'arrêt = distance de réaction + distance de freinage.',
      'Temps de réaction moyen : 1 seconde (1,5 à 2 s si fatigue, alcool, distraction).',
      'À 50 km/h : ~14 m de réaction + ~14 m de freinage = ~28 m total.',
      'À 90 km/h : ~25 m de réaction + ~45 m de freinage = ~70 m total.',
      'À 130 km/h : ~36 m de réaction + ~94 m de freinage = ~130 m total.',
      'Sur sol mouillé : distance de freinage multipliée par 2. Sur verglas : par 10.',
    ],
    whyMatters: "Quand tu vois le danger, c'est déjà trop tard. La distance de sécurité avec le véhicule devant = 2 secondes en temps sec, 3 sous pluie, 4+ par mauvais temps. Cette règle te sauve la vie.",
  },
  'violence-du-choc': {
    pdfHref: '/docs/Violence_du_choc.pdf',
    title: 'La violence du choc : ce que ton corps subit vraiment',
    category: 'Risques & comportements',
    summary: "Lors d'un choc à 50 km/h, un corps de 70 kg subit une force équivalente à 7 tonnes pendant quelques millisecondes. Sans ceinture, le pare-brise traverse une chair non protégée à pleine vitesse.",
    keyPoints: [
      'Choc à 50 km/h ≈ chute libre du 3e étage. Choc à 90 km/h ≈ du 10e étage.',
      'Décélération mesurée en "G" : à 80 km/h sur arrêt sec, 20 à 30 G sur 1/10e de seconde.',
      'Sans ceinture : ton corps continue à 50 km/h jusqu\'à percuter le pare-brise, le volant, le passager devant.',
      'À 50 km/h sans ceinture : 80 % de risque de blessures graves. Avec ceinture : ~10 %.',
      'L\'airbag SEUL ne suffit pas — il est conçu pour fonctionner AVEC la ceinture.',
    ],
    whyMatters: "Attacher sa ceinture prend 2 secondes. C'est le geste qui divise par 5 ton risque de mourir en cas d'accident. Toujours. Même sur 500 mètres en ville.",
  },
  'champ-visuel': {
    pdfHref: '/docs/Champ_visuel.pdf',
    title: 'Champ visuel du conducteur : voir sans tout regarder',
    category: 'Risques & comportements',
    summary: "Notre cerveau ne traite qu'environ 2 % de ce que les yeux captent. Comprendre comment fonctionne ton champ visuel transforme ta façon de conduire.",
    keyPoints: [
      'Champ visuel total horizontal : ~180° au repos. Mais ne reste précis qu\'à 2-3° autour du point fixé.',
      'À 50 km/h : champ utile ~100°. À 130 km/h : ~30° (effet tunnel).',
      'La vision périphérique détecte le mouvement — base du repérage des dangers latéraux.',
      'Vision nocturne : 5 à 10 minutes nécessaires pour adapter l\'œil après un éblouissement.',
      'Fixer l\'écran du téléphone 2 s à 50 km/h = parcourir 28 m sans rien voir.',
    ],
    whyMatters: "Plus tu roules vite, plus ton champ visuel rétrécit et plus tu perds l\'info périphérique. C\'est mécanique, pas une question d\'attention.",
  },
  'le-permis-de-conduire': {
    pdfHref: '/docs/Le_permis_de_conduire.pdf',
    title: 'Permis B : règles, probatoire, points et sanctions',
    category: 'Réglementaire & assurance',
    summary: "Synthèse de l'essentiel à connaître sur le permis B : conditions d'obtention, période probatoire, capital de points, infractions et sanctions associées.",
    keyPoints: [
      'Permis probatoire : 3 ans (2 si AAC). Capital de 6 points, monté à 12 progressivement.',
      'Plafond annuel d\'acquisition : +2 points/an en classique, +3 si AAC. Aucune infraction sur l\'année = points crédités.',
      'Stage de récupération de points : 4 points récupérés. 1 stage/an maximum.',
      'Solde à 0 = permis invalidé. Repassage du Code et de la pratique obligatoires.',
      'Excès > 50 km/h : -6 points, suspension immédiate, amende 1500 €, voire annulation.',
    ],
    whyMatters: "En probatoire, tu joues avec un capital très limité. Une infraction \"banale\" (téléphone tenu en main : -3 points) peut suffire à te faire passer en stage obligatoire.",
  },
  'reglementation-routiere': {
    pdfHref: '/docs/Reglementation_routiere.pdf',
    title: 'Réglementation routière : les règles que tu vas appliquer chaque jour',
    category: 'Réglementaire & assurance',
    summary: "Synthèse à jour des règles essentielles du Code de la route : panneaux, priorités, vitesses, signalisation horizontale et verticale.",
    keyPoints: [
      'Hiérarchie de signalisation : feu > police > signal vertical > marquage au sol > règle générale.',
      'Vitesses : 50 en agglomération · 80 hors agglo (90 si conditions) · 110 routes à chaussées séparées · 130 autoroute (110 sous pluie).',
      'Permis probatoire : 80 / 100 / 110 sur autoroute.',
      'Priorité à droite par défaut hors signalisation contraire. Stop = arrêt absolu derrière la ligne.',
      'Distances de sécurité : règle des 2 secondes (3 sous pluie, 4 par mauvais temps).',
    ],
    whyMatters: "Tu vas appliquer ces règles dans 90 % de tes situations de conduite. Plus tu les maîtrises mentalement, plus ta conduite devient fluide et sûre.",
  },
  'attestation-assurance-aac-cs': {
    pdfHref: '/docs/Attestation_assurance_AAC_CS.pdf',
    title: "Attestation d'assurance AAC & CS : le formulaire à faire remplir",
    category: 'Réglementaire & assurance',
    summary: "Le document officiel en 2 volets pour la conduite accompagnée (AAC) ou supervisée (CS) : la demande d'extension de garantie remplie par le souscripteur + la lettre d'accord signée par l'assureur.",
    keyPoints: [
      "Volet 1 · Demande d'extension : élève (nom, date de naissance, NEPH), véhicule(s), contrat (n° de police, bonus-malus), accompagnateur(s) et cachet de l'auto-école.",
      'Chaque accompagnateur doit détenir le permis B depuis ≥ 5 ans sans interruption et être conducteur dénommé au contrat.',
      "Volet 2 · Lettre d'accord de l'assureur : responsabilité civile + dommages, avec cachet et signature de la compagnie.",
      "L'extension de garantie ne peut pas entraîner de surcoût ni de modification de franchise (mention légale du formulaire).",
      "L'extension prend effet à la date de l'attestation de fin de formation initiale (AFFI) ou de l'autorisation de conduite supervisée.",
    ],
    whyMatters: "Sans cet accord écrit de l'assureur, impossible de démarrer la conduite accompagnée : en cas d'accident, la garantie peut être refusée. À faire remplir AVANT le rendez-vous préalable.",
  },
  'assurance-automobile': {
    pdfHref: '/docs/Assurance_automobile.pdf',
    title: 'Assurance automobile : ce qu\'il faut comprendre AVANT de signer',
    category: 'Réglementaire & assurance',
    summary: "L'assurance auto est obligatoire dès que tu conduis. Choisir la bonne formule te protège contre des dettes potentiellement énormes en cas d'accident.",
    keyPoints: [
      'Responsabilité civile (RC) = MINIMUM légal. Couvre les dommages causés aux autres, jamais à toi ni à ton véhicule.',
      'Tiers étendu = RC + vol/incendie/bris de glace. Conseillé pour véhicule d\'occasion de valeur modérée.',
      'Tous risques = couverture maximale, y compris tes propres dommages. Conseillé pour véhicule neuf ou récent.',
      'Bonus-malus : départ à 1,00. -5 % par an sans accident. Plancher à 0,50 après 13 ans.',
      'Jeune conducteur : surprime de 100 % la 1re année, 50 % la 2e, 25 % la 3e. Réduite si AAC.',
    ],
    whyMatters: "Sans assurance, un accident peut te coûter des centaines de milliers d'euros toute ta vie. AAC = entre -25 % et -50 % de surprime jeune conducteur — gain réel.",
  },
  'bareme-contraventions': {
    pdfHref: '/docs/Bareme_contraventions_points.pdf',
    title: 'Barème contraventions & points : combien ça coûte vraiment',
    category: 'Réglementaire & assurance',
    summary: "Tableau de référence des infractions les plus fréquentes, des amendes encourues et des points retirés. À avoir en tête avant de \"prendre des libertés\".",
    keyPoints: [
      'Téléphone tenu en main : 135 € + -3 points. Si en plus excès de vitesse : suspension du permis.',
      'Ceinture non attachée : 135 € + -3 points (chaque passager non attaché = même sanction pour le conducteur).',
      'Stop non marqué : 135 € + -4 points.',
      'Excès de vitesse < 20 km/h en agglo : 135 € + -1 point. Hors agglo : 68 € + -1 point.',
      'Excès > 50 km/h : 1 500 € + -6 points + suspension/annulation possible.',
      'Refus de priorité : 135 € + -4 points.',
    ],
    whyMatters: "En probatoire avec 6 points, deux infractions \"moyennes\" suffisent à te mettre en danger administratif. Le coût total (amende + assurance qui grimpe + stage) dépasse souvent 1 000 €.",
  },
};

export const FICHE_SLUGS = Object.keys(RESSOURCES_FICHES);

// Helper : retrouver un slug à partir du href PDF
export function slugFromHref(href) {
  return FICHE_SLUGS.find((s) => RESSOURCES_FICHES[s].pdfHref === href);
}
